<template>
  <div class="container home">

    <div class="site-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-12">
                <div class="section-title">
                  <h2>Editor's Pick</h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="post-entry-1">
                  <a href="#">
                    <img src="@/assets/images/img_h_1.jpg" alt="Image" class="img-fluid" />
                  </a>
                  <h2>
                    <a href="#">{{ blogs[0].title }}</a>
                  </h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi temporibus praesentium neque, voluptatum quam quibusdam.</p>
                  <div class="post-meta">
                    <span class="d-block">
                      <a href="#">Dave Rogers</a> in
                      <a href="#">News</a>
                    </span>
                    <span class="date-read">
                      Jun 14
                      <span class="mx-1">&bullet;</span> 3 min read
                      <span class="icon-star2"></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="post-entry-2 d-flex bg-light" v-for="(blog, index) of blogs" :key="index" >
                  <div
                    class="thumbnail"
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/img_v_1.jpg') + ')' }"
                  ></div>
                  <div class="contents">
                    <h2 @click="chooseBlog(blog)" style="cursor:pointer;">
                      {{ blog.title }}
                      <!-- <a href="#">{{ blog.get('title') }}</a> -->
                    </h2>
                    <div class="post-meta">
                      <span class="d-block">
                        <a href="#">Dave Rogers</a> in
                        <a href="#">News</a>
                      </span>
                      <span class="date-read">
                        Jun 14
                        <span class="mx-1">&bullet;</span> 3 min read
                        <span class="icon-star2"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- <div class="post-entry-2 d-flex">
                  <div
                    class="thumbnail"
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/img_v_2.jpg') + ')' }"
                  ></div>
                  <div class="contents">
                    <h2>
                      <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                    </h2>
                    <div class="post-meta">
                      <span class="d-block">
                        <a href="#">Dave Rogers</a> in
                        <a href="#">News</a>
                      </span>
                      <span class="date-read">
                        Jun 14
                        <span class="mx-1">&bullet;</span> 3 min read
                        <span class="icon-star2"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="post-entry-2 d-flex">
                  <div
                    class="thumbnail"
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/img_v_3.jpg') + ')' }"
                  ></div>
                  <div class="contents">
                    <h2>
                      <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                    </h2>
                    <div class="post-meta">
                      <span class="d-block">
                        <a href="#">Dave Rogers</a> in
                        <a href="#">News</a>
                      </span>
                      <span class="date-read">
                        Jun 14
                        <span class="mx-1">&bullet;</span> 3 min read
                        <span class="icon-star2"></span>
                      </span>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="section-title">
              <h2>Trending</h2>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">01</div>
              <div class="trend-contents">
                <h2>
                  <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">02</div>
              <div class="trend-contents">
                <h2>
                  <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">03</div>
              <div class="trend-contents">
                <h2>
                  <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">04</div>
              <div class="trend-contents">
                <h2>
                  <a href="#">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <p>
              <a href="#" class="more">
                See All Trends
                <span class="icon-keyboard_arrow_right"></span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Parse from 'parse'

export default {
  name: "Home",
  data() {
    return {
      blogs: [{title: ''}]
    };
  },
  components: {},
  mounted() {
    this.retrievePosts();
    console.log(this.blogs)
  },
  methods: {
    retrievePosts() {
      const Posts = Parse.Object.extend('Posts');
      let q = new Parse.Query(Posts)

      q.equalTo('approve', true);
      q.include('author');
      q.include('category');

      q.find().then((obj) => {
        let o = JSON.stringify(obj)
        this.blogs = JSON.parse(o);
        console.log('news :: ', obj);
      }, (err) => {
        console.log(err)
      })
    },
    chooseBlog(blog) {
      console.log('blog', blog)
      this.$router.push({ path: 'view', query: { slug: blog.slug, id: blog.objectId } })
    }
  }
};
</script>

<style scoped>
.site-section {
  padding: 2.5em 0;
}
@media (min-width: 768px) {
  .site-section {
    padding: 7em 0;
  }
}
.site-section.site-section-sm {
  padding: 4em 0;
}

.site-section-heading {
  padding-bottom: 20px;
  margin-bottom: 0px;
  position: relative;
  font-size: 2.5rem;
}
@media (min-width: 768px) {
  .site-section-heading {
    font-size: 3rem;
  }
}
</style>